import additionalProperties, {isAdditionalPropertiesAction} from 'ApplicationEntry/ducks/additionalProperties';
import agentInformation, {isAgentInformationAction} from 'ApplicationEntry/ducks/agentInformation';
import agentList, {isAgentListAction} from 'ApplicationEntry/ducks/agentList';
import applicantDemographics, {isApplicantDemographicsAction} from 'ApplicationEntry/ducks/applicantDemographics';
import AWDStatus, {isAWDStatusAction} from 'ApplicationEntry/ducks/AWDStatus';
import billingAgent, {isBillingAgentAction} from 'ApplicationEntry/ducks/billingAgent';
import billingModes, {isBillingModesAction} from 'ApplicationEntry/ducks/billingModes';
import caseDetails, {CaseDetailsAction, isCaseDetailsAction} from 'ApplicationEntry/ducks/caseDetails';
import contingentBeneficiary, {isContingentBeneficiaryAction} from 'ApplicationEntry/ducks/contingentBeneficiary';
import contingentBeneficiaryList, {
  isContingentBeneficiaryListAction,
} from 'ApplicationEntry/ducks/contingentBeneficiaryList';
import dependentLists, {isDependentListAction} from 'ApplicationEntry/ducks/dependentLists';
import dependents, {isDependentsAction} from 'ApplicationEntry/ducks/dependents';
import hippaTrustees, {isHippaTrusteeAction} from 'ApplicationEntry/ducks/hippaTrustees';
import messages, {isMessagesAction} from 'ApplicationEntry/ducks/messages';
import ownerInfo, {isOwnerInfoAction} from 'ApplicationEntry/ducks/ownerInfo';
import planCode, {isPlanCodeAction} from 'ApplicationEntry/ducks/planCode';
import planCodes, {isPlanCodesAction} from 'ApplicationEntry/ducks/planCodes';
import policyRecord, {isPolicyRecordAction} from 'ApplicationEntry/ducks/policyRecord';
import premium, {isPremiumAction} from 'ApplicationEntry/ducks/premium';
import primaryBeneficiaryList, {isPrimaryBeneficiaryListAction} from 'ApplicationEntry/ducks/primaryBeneficiaryList';
import {getPlanCodes, getPremiumDetails, getSelectedPolicy} from 'ApplicationEntry/ducks/productRiders';
import accident, {isAccidentAction} from 'ApplicationEntry/ducks/ProductsRiders/accident';
import accidentNewYork, {isAccidentNewYorkAction} from 'ApplicationEntry/ducks/ProductsRiders/accidentNewYork';
import aip, {isAIPAction} from 'ApplicationEntry/ducks/ProductsRiders/aip';
import cancer, {isCancerAction} from 'ApplicationEntry/ducks/ProductsRiders/cancer';
import criticalIllness, {isCriticalIllnessAction} from 'ApplicationEntry/ducks/ProductsRiders/criticalIllness';
import criticalIllnessNY, {isCriticalIllnessNYAction} from 'ApplicationEntry/ducks/ProductsRiders/criticalIllnessNY';
import disability, {isDisabilityAction} from 'ApplicationEntry/ducks/ProductsRiders/disability';
import glterm, {isGLTERMAction} from 'ApplicationEntry/ducks/ProductsRiders/glterm';
import heartStroke, {isHeartStrokeAction} from 'ApplicationEntry/ducks/ProductsRiders/heartStroke';
import icrtn, {isICRTNAction} from 'ApplicationEntry/ducks/ProductsRiders/icrtn';
import iwl, {isIWLAction} from 'ApplicationEntry/ducks/ProductsRiders/iwl';
import pinCare, {isPinCareAction} from 'ApplicationEntry/ducks/ProductsRiders/pinCare';
import shop, {isShopAction} from 'ApplicationEntry/ducks/ProductsRiders/shop';
import universalLife, {isULAction} from 'ApplicationEntry/ducks/ProductsRiders/universalLife';
import {
  getGroupApplicantDemographics,
  getOrdinaryApplicantDemographics,
  getOwnerInfo,
} from 'ApplicationEntry/ducks/qualityApplicantInformation';
import {
  getContingentBeneficiaryList,
  getDependentList,
  getPrimaryBeneficiaries,
} from 'ApplicationEntry/ducks/qualityBeneficiaries';
import {getAgentsList, getGroupBillingAgent, getOrdinaryBillingAgent} from 'ApplicationEntry/ducks/qualityBillingAgent';
import secondaryAddressee, {isSecondaryAddresseeAction} from 'ApplicationEntry/ducks/secondaryAddressee';
import underwritingQuestions, {isUWQuestionsAction} from 'ApplicationEntry/ducks/underwritingQuestions';
import verifyCriticalInformation, {
  isVerifyCriticalInformationAction,
} from 'ApplicationEntry/ducks/verifyCriticalInformation';
import {getAppEntryType, WorkQueueActionType} from 'ApplicationEntry/ducks/workQueue';
import {EmptyAdditionalProperties, ValidAdditionalProperties} from 'ApplicationEntry/models/AdditionalProperties';
import {EmptyAgent} from 'ApplicationEntry/models/AgentInformation';
import {EmptyAgentList} from 'ApplicationEntry/models/AgentList';
import * as A from 'ApplicationEntry/models/Application';
import {ApplicationModeType} from 'ApplicationEntry/models/ApplicationModeType';
import {ApplicationType} from 'ApplicationEntry/models/ApplicationType';
import {EmptyGroupAWDStatus, ValidGroupAWDStatus} from 'ApplicationEntry/models/AWDStatus/GroupAWDStatus';
import {ValidNewYorkAWDStatus} from 'ApplicationEntry/models/AWDStatus/NewYorkAWDStatus';
import {EmptyOrdinaryAWDStatus, ValidOrdinaryAWDStatus} from 'ApplicationEntry/models/AWDStatus/OrdinaryAWDStatus';
import {EmptyBillingModes, ValidBillingModes} from 'ApplicationEntry/models/BillingModes';
import {UserAssignedCaseNumber} from 'ApplicationEntry/models/CaseNumber';
import {EmptyContingentBeneficiary} from 'ApplicationEntry/models/ContingentBeneficiary';
import {EmptyContingentBeneficiaryList} from 'ApplicationEntry/models/ContingentBeneficiaryList';
import {EmptyDependentList} from 'ApplicationEntry/models/DependentLists';
import {EmptyDependents} from 'ApplicationEntry/models/Dependents';
import {EmptyGroupApplicantDemographics} from 'ApplicationEntry/models/GroupApplicantDemographics';
import {
  EmptyGroupApplication,
  InvalidGroupApplication,
  ValidGroupApplication,
} from 'ApplicationEntry/models/GroupApplication';
import {EmptyGroupBillingAgent} from 'ApplicationEntry/models/GroupBillingAgent';
import {ValidGroupCaseDetails} from 'ApplicationEntry/models/GroupCaseDetails';
import {EmptyGroupVerifyCriticalInformation} from 'ApplicationEntry/models/GroupVerifyCriticalInformation';
import {EmptyHippaTrustees} from 'ApplicationEntry/models/HippaTrustees';
import {EmptyMessage} from 'ApplicationEntry/models/Messages';
import * as MA from 'ApplicationEntry/models/ModalApplication';
import {EmptyNewYorkApplicantDemographics} from 'ApplicationEntry/models/NewYorkApplicantDemographics';
import {EmptyNewYorkApplication, InvalidNewYorkApplication} from 'ApplicationEntry/models/NewYorkApplication';
import {EmptyNewYorkBillingAgent} from 'ApplicationEntry/models/NewYorkBillingAgent';
import {ValidNewYorkCaseDetails} from 'ApplicationEntry/models/NewYorkCaseDetails';
import {EmptyNewYorkVerifyCriticalInformation} from 'ApplicationEntry/models/NewYorkVerifyCriticalInformation';
import {EmptyOrdinaryApplicantDemographics} from 'ApplicationEntry/models/OrdinaryApplicantDemographics';
import {
  EmptyOrdinaryApplication,
  InvalidOrdinaryApplication,
  ValidOrdinaryApplication,
} from 'ApplicationEntry/models/OrdinaryApplication';
import {EmptyOrdinaryBillingAgent} from 'ApplicationEntry/models/OrdinaryBillingAgent';
import {ValidOrdinaryCaseDetails} from 'ApplicationEntry/models/OrdinaryCaseDetails';
import {EmptyOrdinaryVerifyCriticalInformation} from 'ApplicationEntry/models/OrdinaryVerifyCriticalInformation';
import {EmptyOwnerInfo} from 'ApplicationEntry/models/OwnerInfo';
import {EmptyPlanCode} from 'ApplicationEntry/models/PlanCode';
import {EmptyPlanCodes} from 'ApplicationEntry/models/PlanCodes';
import {UserAssignedPolicyNumber} from 'ApplicationEntry/models/PolicyNumber';
import {EmptyPolicyRecord, ValidPolicyRecord} from 'ApplicationEntry/models/PolicyRecord';
import {isLoadedPolicyTypes, LoadedPolicyTypes} from 'ApplicationEntry/models/PolicyTypes';
import {EmptyPremium} from 'ApplicationEntry/models/Premium';
import {EmptyPrimaryBeneficiary} from 'ApplicationEntry/models/PrimaryBeneficiary';
import {EmptyPrimaryBeneficiaryList} from 'ApplicationEntry/models/PrimaryBeneficiaryList';
import {EmptyGroupAccident} from 'ApplicationEntry/models/ProductsRiders/Accident/GroupAccident';
import {EmptyNewYorkAccident} from 'ApplicationEntry/models/ProductsRiders/Accident/NewYorkAccident';
import {EmptyOrdinaryAccident} from 'ApplicationEntry/models/ProductsRiders/Accident/OrdinaryAccident';
import {EmptyGroupAccidentNewYork} from 'ApplicationEntry/models/ProductsRiders/AccidentNewYork/GroupAccidentNewYork';
import {EmptyNewYorkAccidentNewYork} from 'ApplicationEntry/models/ProductsRiders/AccidentNewYork/NewYorkAccidentNewYork';
import {EmptyOrdinaryAccidentNewYork} from 'ApplicationEntry/models/ProductsRiders/AccidentNewYork/OrdinaryAccidentNewYork';
import {EmptyGroupAIP} from 'ApplicationEntry/models/ProductsRiders/AIP/GroupAIP';
import {EmptyNewYorkAIP} from 'ApplicationEntry/models/ProductsRiders/AIP/NewYorkAIP';
import {EmptyOrdinaryAIP} from 'ApplicationEntry/models/ProductsRiders/AIP/OrdinaryAIP';
import {EmptyGroupCancer} from 'ApplicationEntry/models/ProductsRiders/Cancer/GroupCancer';
import {EmptyNewYorkCancer} from 'ApplicationEntry/models/ProductsRiders/Cancer/NewYorkCancer';
import {EmptyOrdinaryCancer} from 'ApplicationEntry/models/ProductsRiders/Cancer/OrdinaryCancer';
import {EmptyGroupCriticalIllness} from 'ApplicationEntry/models/ProductsRiders/CriticalIllness/GroupCriticalIllness';
import {EmptyNewYorkCriticalIllness} from 'ApplicationEntry/models/ProductsRiders/CriticalIllness/NewYorkCriticalIllness';
import {EmptyOrdCriticalIllness} from 'ApplicationEntry/models/ProductsRiders/CriticalIllness/OrdinaryCriticalIllness';
import {EmptyGroupCriticalIllnessNY} from 'ApplicationEntry/models/ProductsRiders/CriticalIllnessNY/GroupCriticalIllnessNY';
import {EmptyNewYorkCriticalIllnessNY} from 'ApplicationEntry/models/ProductsRiders/CriticalIllnessNY/NewYorkCriticalIllnessNY';
import {EmptyOrdinaryCriticalIllnessNY} from 'ApplicationEntry/models/ProductsRiders/CriticalIllnessNY/OrdinaryCriticalIllnessNY';
import {EmptyGroupDisability} from 'ApplicationEntry/models/ProductsRiders/Disability/GroupDisability';
import {EmptyNewYorkDisability} from 'ApplicationEntry/models/ProductsRiders/Disability/NewYorkDisability';
import {EmptyOrdDisability} from 'ApplicationEntry/models/ProductsRiders/Disability/OrdinaryDisability';
import {ProductRiderGroups, ProductsRidersPolicyType} from 'ApplicationEntry/models/ProductsRiders/Families';
import {EmptyGroupGLTERM} from 'ApplicationEntry/models/ProductsRiders/GLTERM/GroupGLTERM';
import {EmptyNewYorkGLTERM} from 'ApplicationEntry/models/ProductsRiders/GLTERM/NewYorkGLTERM';
import {EmptyOrdGLTERM} from 'ApplicationEntry/models/ProductsRiders/GLTERM/OrdinaryGLTERM';
import {EmptyGroupHeartStroke} from 'ApplicationEntry/models/ProductsRiders/HeartStroke/GroupHeartStroke';
import {EmptyNewYorkHeartStroke} from 'ApplicationEntry/models/ProductsRiders/HeartStroke/NewYorkHeartStroke';
import {EmptyOrdinaryHeartStroke} from 'ApplicationEntry/models/ProductsRiders/HeartStroke/OrdinaryHeartStroke';
import {EmptyGroupICRTN} from 'ApplicationEntry/models/ProductsRiders/ICRTN/GroupICRTN';
import {EmptyNewYorkICRTN} from 'ApplicationEntry/models/ProductsRiders/ICRTN/NewYorkICRTN';
import {EmptyOrdinaryICRTN} from 'ApplicationEntry/models/ProductsRiders/ICRTN/OrdinaryICRTN';
import {EmptyGroupIWL} from 'ApplicationEntry/models/ProductsRiders/IWL/GroupIWL';
import {EmptyNewYorkIWL} from 'ApplicationEntry/models/ProductsRiders/IWL/NewYorkIWL';
import {EmptyOrdinaryIwl} from 'ApplicationEntry/models/ProductsRiders/IWL/OrdinaryIWL';
import {EmptyGroupPinCare} from 'ApplicationEntry/models/ProductsRiders/PinCare/GroupPinCare';
import {EmptyNewYorkPinCare} from 'ApplicationEntry/models/ProductsRiders/PinCare/NewYorkPinCare';
import {EmptyOrdinaryPinCare} from 'ApplicationEntry/models/ProductsRiders/PinCare/OrdinaryPinCare';
import {Product} from 'ApplicationEntry/models/ProductsRiders/PlanModel';
import {EmptyGroupShop} from 'ApplicationEntry/models/ProductsRiders/Shop/GroupShop';
import {EmptyNewYorkShop} from 'ApplicationEntry/models/ProductsRiders/Shop/NewYorkShop';
import {EmptyOrdShop} from 'ApplicationEntry/models/ProductsRiders/Shop/OrdinaryShop';
import {EmptyGroupUL} from 'ApplicationEntry/models/ProductsRiders/UniversalLife/GroupUL';
import {EmptyNewYorkUL} from 'ApplicationEntry/models/ProductsRiders/UniversalLife/NewYorkUL';
import {EmptyOrdUL} from 'ApplicationEntry/models/ProductsRiders/UniversalLife/OrdinaryUL';
import {EmptySecondaryAddressee} from 'ApplicationEntry/models/SecondaryAddressee';
import {EmptyUWQuestions} from 'ApplicationEntry/models/UnderwritingQuestions';
import {EmptyString, NonEmptyString} from 'Core/models/EmptyString';
import {createAction} from 'Shared/utilities/actionCreator';

export enum ApplicationActionType {
  SET_APPLICATION_TYPE = 'application/SET_APPLICATION_TYPE',
  CLEAR = 'application/CLEAR',
  RESET = 'application/RESET',
  RESET_EXCEPT_CASE_DETAILS_POLICY_RECORD_AND_BILLING_MODES = 'application/RESET_EXCEPT_CASE_DETAILS_POLICY_RECORD_AND_BILLING_MODES',
  SAVE = 'application/SAVE',
  VALIDATE_AUE = 'application/VALIDATE_AUE',
  RESET_PRODUCTS_AND_RIDERS_SECTION = 'application/RESET_PRODUCTS_AND_RIDERS_SECTION',
  SET_APPLICATION_MODE = 'application/SET_APPLICATION_MODE',
  GET_APPLICATION = 'application/GET_APPLICATION',
  SET_APPLICATION = 'application/SET_APPLICATION',
  ISSUE_POLICY_QUALITY = 'application/ISSUE_POLICY_QUALITY',
}

export const setApplicationType = (
  applicationType: ApplicationType,
  applicationMode: ApplicationModeType,
  beneficiaryInformation: object[],
  enrollmentData: object,
  policyNumber: string,
  products: Product[],
  achIndicatorQuality: boolean,
  pacDataResultData: object
) =>
  createAction(ApplicationActionType.SET_APPLICATION_TYPE, {
    applicationType,
    applicationMode,
    beneficiaryInformation,
    enrollmentData,
    policyNumber,
    products,
    achIndicatorQuality,
    pacDataResultData
  });
export const clearApplication = () => createAction(ApplicationActionType.CLEAR);
export const resetApplication = () => createAction(ApplicationActionType.RESET);
export const resetApplicationExceptCaseDetailsAndPolicyRecord = () =>
  createAction(ApplicationActionType.RESET_EXCEPT_CASE_DETAILS_POLICY_RECORD_AND_BILLING_MODES);
export const resetApplicationProductsAndRidersSection = () =>
  createAction(ApplicationActionType.RESET_PRODUCTS_AND_RIDERS_SECTION);
export const issuePolicy = (policyNumber: string) =>
  createAction(ApplicationActionType.ISSUE_POLICY_QUALITY, {policyNumber});

type ApplicationState = MA.ModalApplication;
const DEFAULT_STATE = MA.UndeterminedModalApplication;

type ApplicationAction =
  | CaseDetailsAction
  | ReturnType<typeof setApplicationType>
  | ReturnType<typeof getAppEntryType>
  | ReturnType<typeof clearApplication>
  | ReturnType<typeof resetApplication>
  | ReturnType<typeof resetApplicationProductsAndRidersSection>
  | ReturnType<typeof resetApplicationExceptCaseDetailsAndPolicyRecord>
  | ReturnType<typeof issuePolicy>;
  // | ReturnType<typeof setAchIndicator>

const handleApplicationAction = (
  state: A.ValidApplication | A.InvalidApplication,
  action: ApplicationAction
): A.Application => {
  if (isCaseDetailsAction(action)) {
    return A.changeCaseDetails(caseDetails(state.caseDetails, action))(state);
  } else if (isApplicantDemographicsAction(action)) {
    return A.changeApplicantDemographics(applicantDemographics(state.applicantDemographics, action))(state);
  } else if (isOwnerInfoAction(action)) {
    return A.changeOwnerInfo(ownerInfo(state.ownerInfo, action))(state);
  } else if (isSecondaryAddresseeAction(action)) {
    return A.changeSecondaryAddressee(secondaryAddressee(state.secondaryAddressee, action))(state);
  } else if (isContingentBeneficiaryAction(action)) {
    return A.changeContingentBeneficiary(contingentBeneficiary(state.contingentBeneficiary, action))(state);
  } else if (isPrimaryBeneficiaryListAction(action)) {
    return A.changePrimaryBeneficiaryList(primaryBeneficiaryList(state.primaryBeneficiaryList, action))(state);
  } else if (isContingentBeneficiaryListAction(action)) {
    return A.changeContingentBeneficiaryList(contingentBeneficiaryList(state.contingentBeneficiaryList, action))(state);
  } else if (isCriticalIllnessAction(action)) {
    return A.changeCriticalIllness(criticalIllness(state.criticalIllness, action))(state);
  } else if (isICRTNAction(action)) {
    return A.changeICRTN(icrtn(state.icrtn, action))(state);
  } else if (isCancerAction(action)) {
    return A.changeCancer(cancer(state.cancer, action))(state);
  } else if (isDependentsAction(action)) {
    return A.changeDependents(dependents(state.dependents, action))(state);
  } else if (isDependentListAction(action)) {
    return A.changeDependentList(dependentLists(state.dependentLists, action))(state);
  } else if (isPolicyRecordAction(action)) {
    return A.changePolicyRecord(policyRecord(state.policyRecord, action))(state);
  } else if (isBillingAgentAction(action)) {
    return A.changeBillingAgent(billingAgent(state.billingAgent, action))(state);
  } else if (isAgentInformationAction(action)) {
    return A.changeAgent(agentInformation(state.agentInformation, action))(state);
  } else if (isAgentListAction(action)) {
    return A.changeAgentList(agentList(state.agentList, action))(state);
  } else if (isMessagesAction(action)) {
    return A.changeMessage(messages(state.messages, action))(state);
  } else if (isBillingModesAction(action)) {
    return A.changeBillingModes(billingModes(state.billingModes, action))(state);
  } else if (isAWDStatusAction(action)) {
    return A.changeAWDStatus(AWDStatus(state.awdStatus, action))(state);
  } else if (isVerifyCriticalInformationAction(action)) {
    return A.changeVerifyCriticalInformation(verifyCriticalInformation(state.verifyCriticalInformation, action))(state);
  } else if (isDisabilityAction(action)) {
    return A.changeDisability(disability(state.disability, action))(state);
  } else if (isShopAction(action)) {
    return A.changeShop(shop(state.shop, action))(state);
  } else if (isIWLAction(action)) {
    return A.changeIWL(iwl(state.iwl, action))(state);
  } else if (isHeartStrokeAction(action)) {
    return A.changeHeartStroke(heartStroke(state.heartStroke, action))(state);
  } else if (isAccidentAction(action)) {
    return A.changeAccident(accident(state.accident, action))(state);
  } else if (isUWQuestionsAction(action)) {
    return A.changeUWQuestions(underwritingQuestions(state.uwQuestions, action))(state);
  } else if (isULAction(action)) {
    return A.changeUniversalLife(universalLife(state.universalLife, action))(state);
  } else if (isGLTERMAction(action)) {
    return A.changeGLTERM(glterm(state.glterm, action))(state);
  } else if (isPinCareAction(action)) {
    return A.changePinCare(pinCare(state.pinCare, action))(state);
  } else if (isAccidentNewYorkAction(action)) {
    return A.changeAccidentNewYork(accidentNewYork(state.accidentNewYork, action))(state);
  } else if (isCriticalIllnessNYAction(action)) {
    return A.changeCriticalIllnessNY(criticalIllnessNY(state.criticalIllnessNY, action))(state);
  } else if (isHippaTrusteeAction(action)) {
    return A.changeHippaTrustees(hippaTrustees(state.hippaTrustees, action))(state);
  } else if (isPremiumAction(action)) {
    return A.changePremium(premium(state.premium, action))(state);
  } else if (isAIPAction(action)) {
    return A.changeAIP(aip(state.aip, action))(state);
  } else if (isPlanCodeAction(action)) {
    return A.changePlanCode(planCode(state.planCode, action))(state);
  } else if (isPlanCodesAction(action)) {
    return A.changePlanCodes(planCodes(state.planCodes, action))(state);
  } else if (isAdditionalPropertiesAction(action)) {
    return A.changeAdditionalProperties(additionalProperties(state.additionalProperties, action))(state);
  } else {
    return state;
  }
};

export default (state: ApplicationState = DEFAULT_STATE, action: ApplicationAction): MA.ModalApplication => {
  const ModalApplication = state as MA.InvalidModalApplication | MA.ValidModalApplication;
  const mode = ModalApplication.mode;
  const application = ModalApplication.application;

  if (action.type === ApplicationActionType.CLEAR) {
    return DEFAULT_STATE;
  } else if (action.type === ApplicationActionType.RESET) {
    if (application.key === 'InvalidGroupApplication' || application.key === 'ValidGroupApplication') {
      return MA.ValidModalApplication.create(mode, EmptyGroupApplication);
    } else if (application.key === 'InvalidOrdinaryApplication' || application.key === 'ValidOrdinaryApplication') {
      return MA.ValidModalApplication.create(mode, EmptyOrdinaryApplication);
    } else if (application.key === 'InvalidNewYorkApplication' || application.key === 'ValidNewYorkApplication') {
      return MA.ValidModalApplication.create(mode, EmptyNewYorkApplication);
    }
  } else if (action.type === ApplicationActionType.RESET_PRODUCTS_AND_RIDERS_SECTION) {
    if (application.key === 'InvalidGroupApplication' || application.key === 'ValidGroupApplication') {
      const {productType} = application.caseDetails;

      if (isLoadedPolicyTypes(productType)) {
        const groupApplication = {...application};

        productType.availablePolicyTypes.forEach(policy => {
          if (!productType.selectedPolicyTypes.some(x => x.productGroup! === policy.productGroup!)) {
            if (
              policy.productGroup!.toLowerCase() ===
              ProductRiderGroups[ProductsRidersPolicyType.CriticalIllness].toLowerCase()
            ) {
              groupApplication['criticalIllness'] = EmptyGroupCriticalIllness;
            } else if (
              policy.productGroup!.toLowerCase() === ProductRiderGroups[ProductsRidersPolicyType.Accident].toLowerCase()
            ) {
              groupApplication['accident'] = EmptyGroupAccident;
            } else if (
              policy.productGroup!.toLowerCase() === ProductRiderGroups[ProductsRidersPolicyType.Cancer].toLowerCase()
            ) {
              groupApplication['cancer'] = EmptyGroupCancer;
            } else if (
              policy.productGroup!.toLowerCase() ===
              ProductRiderGroups[ProductsRidersPolicyType.Disability].toLowerCase()
            ) {
              groupApplication['disability'] = EmptyGroupDisability;
            } else if (
              policy.productGroup!.toLowerCase() ===
              ProductRiderGroups[ProductsRidersPolicyType.AccidentNewYork].toLowerCase()
            ) {
              groupApplication['accidentNewYork'] = EmptyGroupAccidentNewYork;
            } else if (
              policy.productGroup!.toLowerCase() === ProductRiderGroups[ProductsRidersPolicyType.PinCare].toLowerCase()
            ) {
              groupApplication['pinCare'] = EmptyGroupPinCare;
            } else if (
              policy.productGroup!.toLowerCase() === ProductRiderGroups[ProductsRidersPolicyType.GLTerm].toLowerCase()
            ) {
              groupApplication['glterm'] = EmptyGroupGLTERM;
            } else if (
              policy.productGroup!.toLowerCase() ===
              ProductRiderGroups[ProductsRidersPolicyType.UniversalLife].toLowerCase()
            ) {
              groupApplication['universalLife'] = EmptyGroupUL;
            } else if (
              policy.productGroup!.toLowerCase() === ProductRiderGroups[ProductsRidersPolicyType.Shop].toLowerCase()
            ) {
              groupApplication['shop'] = EmptyGroupShop;
            } else if (
              policy.productGroup!.toLowerCase() ===
              ProductRiderGroups[ProductsRidersPolicyType.CriticalIllnessNY].toLowerCase()
            ) {
              groupApplication['criticalIllnessNY'] = EmptyGroupCriticalIllnessNY;
            } else if (
              policy.productGroup!.toLowerCase() === ProductRiderGroups[ProductsRidersPolicyType.Gwl].toLowerCase()
            ) {
              groupApplication['iwl'] = EmptyGroupIWL;
            } else if (
              policy.productGroup!.toLowerCase() === ProductRiderGroups[ProductsRidersPolicyType.Aip].toLowerCase()
            ) {
              groupApplication['aip'] = EmptyGroupAIP;
            }
          }
        });

        return MA.ValidModalApplication.create(mode, ValidGroupApplication.createApp(groupApplication));
      }
    } else if (application.key === 'InvalidOrdinaryApplication' || application.key === 'ValidOrdinaryApplication') {
      const {productType} = application.caseDetails;

      if (isLoadedPolicyTypes(productType)) {
        const ordinaryApplication = {...application};

        productType.availablePolicyTypes.forEach(policy => {
          if (!productType.selectedPolicyTypes.some(x => x.productGroup! === policy.productGroup!)) {
            if (
              policy.productGroup!.toLowerCase() ===
              ProductRiderGroups[ProductsRidersPolicyType.CriticalIllness].toLowerCase()
            ) {
              ordinaryApplication['criticalIllness'] = EmptyOrdCriticalIllness;
            } else if (
              policy.productGroup!.toLowerCase() === ProductRiderGroups[ProductsRidersPolicyType.Accident].toLowerCase()
            ) {
              ordinaryApplication['accident'] = EmptyOrdinaryAccident;
            } else if (
              policy.productGroup!.toLowerCase() === ProductRiderGroups[ProductsRidersPolicyType.Cancer].toLowerCase()
            ) {
              ordinaryApplication['cancer'] = EmptyOrdinaryCancer;
            } else if (
              policy.productGroup!.toLowerCase() ===
              ProductRiderGroups[ProductsRidersPolicyType.Disability].toLowerCase()
            ) {
              ordinaryApplication['disability'] = EmptyOrdDisability;
            } else if (
              policy.productGroup!.toLowerCase() ===
              ProductRiderGroups[ProductsRidersPolicyType.HeartStroke].toLowerCase()
            ) {
              ordinaryApplication['heartStroke'] = EmptyOrdinaryHeartStroke;
            } else if (
              policy.productGroup!.toLowerCase() === ProductRiderGroups[ProductsRidersPolicyType.Icrtn].toLowerCase()
            ) {
              ordinaryApplication['icrtn'] = EmptyOrdinaryICRTN;
            } else if (
              policy.productGroup!.toLowerCase() === ProductRiderGroups[ProductsRidersPolicyType.Iwl].toLowerCase()
            ) {
              ordinaryApplication['iwl'] = EmptyOrdinaryIwl;
            } else if (
              policy.productGroup!.toLowerCase() === ProductRiderGroups[ProductsRidersPolicyType.Shop].toLowerCase()
            ) {
              ordinaryApplication['shop'] = EmptyOrdShop;
            }
          }
        });

        return MA.ValidModalApplication.create(mode, ValidOrdinaryApplication.createApp(ordinaryApplication));
      }
    } else if (application.key === 'InvalidNewYorkApplication' || application.key === 'ValidNewYorkApplication') {
      return MA.ValidModalApplication.create(mode, EmptyNewYorkApplication);
    }
  } else if (action.type === ApplicationActionType.RESET_EXCEPT_CASE_DETAILS_POLICY_RECORD_AND_BILLING_MODES) {
    if (application.key === 'InvalidGroupApplication' || application.key === 'ValidGroupApplication') {
      return MA.ValidModalApplication.create(
        mode,
        new InvalidGroupApplication(
          ValidGroupCaseDetails.create(
            application.caseDetails.caseNumber,
            application.caseDetails.policyNumber,
            application.caseDetails.productType,
            application.caseDetails.caseName,
            application.caseDetails.achIndicator,
            application.caseDetails.billingCode,
            application.caseDetails.situsState,
            application.caseDetails.userNameAuthJStamp,
            application.caseDetails.userAuthorizedJStamp,
            application.caseDetails.disableNexttoShowOtherSection,
            application.caseDetails?.disableNexttoShowOtherSectionArr,
            application.caseDetails.messages,
            application.caseDetails.notACH,
            application.caseDetails.policyStatus,
            application.caseDetails.managedStatus,
            application.caseDetails.managedStatusFlag,
          ),
          EmptyGroupApplicantDemographics,
          EmptyOwnerInfo,
          EmptySecondaryAddressee,
          EmptyPrimaryBeneficiaryList,
          EmptyPrimaryBeneficiary,
          EmptyContingentBeneficiary,
          EmptyContingentBeneficiaryList,
          EmptyGroupCriticalIllness,
          EmptyGroupICRTN,
          EmptyGroupCancer,
          EmptyDependents,
          EmptyDependentList,
          ValidPolicyRecord.create(
            application.policyRecord.businessArea,
            application.policyRecord.status,
            application.policyRecord.workType,
            application.policyRecord.coCode,
            application.policyRecord.policyNumber,
            application.policyRecord.bankNumber,
            application.policyRecord.socialSecurityNumber,
            application.policyRecord.firstName,
            application.policyRecord.lastName,
            application.policyRecord.agent,
            application.policyRecord.caseNumber,
            application.policyRecord.priorityIncrease,
            application.policyRecord.stateSigned,
            application.policyRecord.payorNumber
          ),
          EmptyGroupBillingAgent,
          EmptyAgent,
          EmptyAgentList,
          EmptyMessage,
          ValidBillingModes.create(application.billingModes.billingModes),
          ValidGroupAWDStatus.create(
            application.awdStatus.workType,
            application.awdStatus.workType2,
            application.awdStatus.workType3,
            application.awdStatus.status,
            application.awdStatus.status2,
            application.awdStatus.status3,
            application.awdStatus.underwriter,
            application.awdStatus.underwriter2,
            application.awdStatus.underwriter3,
            application.awdStatus.comments,
            application.awdStatus.comments2,
            application.awdStatus.comments3,
            application.awdStatus.override,
            application.awdStatus.override2,
            application.awdStatus.override3,
            application.awdStatus.workTypeList,
            application.awdStatus.statusList,
            application.awdStatus.underwriterList
          ),
          EmptyGroupVerifyCriticalInformation,
          EmptyGroupDisability,
          EmptyGroupShop,
          EmptyGroupIWL,
          EmptyGroupHeartStroke,
          EmptyGroupAccident,
          EmptyUWQuestions,
          EmptyGroupUL,
          EmptyGroupGLTERM,
          EmptyGroupPinCare,
          EmptyGroupAccidentNewYork,
          EmptyGroupCriticalIllnessNY,
          EmptyHippaTrustees,
          EmptyPremium,
          EmptyGroupAIP,
          EmptyPlanCode,
          EmptyPlanCodes,
          EmptyAdditionalProperties
        )
      );
    } else if (application.key === 'InvalidOrdinaryApplication' || application.key === 'ValidOrdinaryApplication') {
      return MA.ValidModalApplication.create(
        mode,
        new InvalidOrdinaryApplication(
          ValidOrdinaryCaseDetails.create(
            application.caseDetails.policyNumber,
            application.caseDetails.productType,
            application.caseDetails?.disableNexttoShowOtherSection,
            application.caseDetails?.disableNexttoShowOtherSectionArr,
            application.caseDetails.achIndicator,
            application.caseDetails.policyStatus,
            application.caseDetails.managedStatus,
            application.caseDetails.managedStatusFlag,
          ),
          EmptyOrdinaryApplicantDemographics,
          EmptyOwnerInfo,
          EmptySecondaryAddressee,
          EmptyPrimaryBeneficiaryList,
          EmptyPrimaryBeneficiary,
          EmptyContingentBeneficiary,
          EmptyContingentBeneficiaryList,
          EmptyOrdCriticalIllness,
          EmptyOrdinaryICRTN,
          EmptyOrdinaryCancer,
          EmptyDependents,
          EmptyDependentList,
          ValidPolicyRecord.create(
            application.policyRecord.businessArea,
            application.policyRecord.status,
            application.policyRecord.workType,
            application.policyRecord.coCode,
            application.policyRecord.policyNumber,
            application.policyRecord.bankNumber,
            application.policyRecord.socialSecurityNumber,
            application.policyRecord.firstName,
            application.policyRecord.lastName,
            application.policyRecord.agent,
            application.policyRecord.caseNumber,
            application.policyRecord.priorityIncrease,
            application.policyRecord.stateSigned,
            application.policyRecord.payorNumber
          ),
          EmptyOrdinaryBillingAgent,
          EmptyAgent,
          EmptyAgentList,
          EmptyMessage,
          ValidBillingModes.create(application.billingModes.billingModes),
          ValidOrdinaryAWDStatus.create(
            application.awdStatus.workType,
            application.awdStatus.workType2,
            application.awdStatus.workType3,
            application.awdStatus.status,
            application.awdStatus.status2,
            application.awdStatus.status3,
            application.awdStatus.underwriter,
            application.awdStatus.underwriter2,
            application.awdStatus.underwriter3,
            application.awdStatus.comments,
            application.awdStatus.comments2,
            application.awdStatus.comments3,
            application.awdStatus.override,
            application.awdStatus.override2,
            application.awdStatus.override3,
            application.awdStatus.workTypeList,
            application.awdStatus.statusList,
            application.awdStatus.underwriterList
          ),
          EmptyOrdinaryVerifyCriticalInformation,
          EmptyOrdDisability,
          EmptyOrdShop,
          EmptyOrdinaryIwl,
          EmptyOrdinaryHeartStroke,
          EmptyOrdinaryAccident,
          EmptyUWQuestions,
          EmptyOrdUL,
          EmptyOrdGLTERM,
          EmptyOrdinaryPinCare,
          EmptyOrdinaryAccidentNewYork,
          EmptyOrdinaryCriticalIllnessNY,
          EmptyHippaTrustees,
          EmptyPremium,
          EmptyOrdinaryAIP,
          EmptyPlanCode,
          EmptyPlanCodes,
          EmptyAdditionalProperties
        )
      );
    } else if (application.key === 'InvalidNewYorkApplication' || application.key === 'ValidNewYorkApplication') {
      return MA.ValidModalApplication.create(
        mode,
        new InvalidNewYorkApplication(
          ValidNewYorkCaseDetails.create(application.caseDetails.policyNumber, application.caseDetails.productType, application.caseDetails.achIndicator, application.caseDetails.policyStatus, application.caseDetails.managedStatus, application.caseDetails.managedStatusFlag),
          EmptyNewYorkApplicantDemographics,
          EmptyOwnerInfo,
          EmptySecondaryAddressee,
          EmptyPrimaryBeneficiaryList,
          EmptyPrimaryBeneficiary,
          EmptyContingentBeneficiary,
          EmptyContingentBeneficiaryList,
          EmptyNewYorkCriticalIllness,
          EmptyNewYorkICRTN,
          EmptyNewYorkCancer,
          EmptyDependents,
          EmptyDependentList,
          ValidPolicyRecord.create(
            application.policyRecord.businessArea,
            application.policyRecord.status,
            application.policyRecord.workType,
            application.policyRecord.coCode,
            application.policyRecord.policyNumber,
            application.policyRecord.bankNumber,
            application.policyRecord.socialSecurityNumber,
            application.policyRecord.firstName,
            application.policyRecord.lastName,
            application.policyRecord.agent,
            application.policyRecord.caseNumber,
            application.policyRecord.priorityIncrease,
            application.policyRecord.stateSigned,
            application.policyRecord.payorNumber
          ),
          EmptyNewYorkBillingAgent,
          EmptyAgent,
          EmptyAgentList,
          EmptyMessage,
          ValidBillingModes.create(application.billingModes.billingModes),
          ValidNewYorkAWDStatus.create(
            application.awdStatus.workType,
            application.awdStatus.workType2,
            application.awdStatus.workType3,
            application.awdStatus.status,
            application.awdStatus.status2,
            application.awdStatus.status3,
            application.awdStatus.underwriter,
            application.awdStatus.underwriter2,
            application.awdStatus.underwriter3,
            application.awdStatus.comments,
            application.awdStatus.comments2,
            application.awdStatus.comments3,
            application.awdStatus.override,
            application.awdStatus.override2,
            application.awdStatus.override3,
            application.awdStatus.workTypeList,
            application.awdStatus.statusList,
            application.awdStatus.underwriterList
          ),
          EmptyNewYorkVerifyCriticalInformation,
          EmptyNewYorkDisability,
          EmptyNewYorkShop,
          EmptyNewYorkIWL,
          EmptyNewYorkHeartStroke,
          EmptyNewYorkAccident,
          EmptyUWQuestions,
          EmptyNewYorkUL,
          EmptyNewYorkGLTERM,
          EmptyNewYorkPinCare,
          EmptyNewYorkAccidentNewYork,
          EmptyNewYorkCriticalIllnessNY,
          EmptyHippaTrustees,
          EmptyPremium,
          EmptyNewYorkAIP,
          EmptyPlanCode,
          EmptyPlanCodes,
          EmptyAdditionalProperties
        )
      );
    }
  }

  return MA.matchModalApplication(state, {
    Invalid: invalidModalApplication =>
      MA.ValidModalApplication.create(
        invalidModalApplication.mode,
        handleApplicationAction(application, action) as A.InvalidApplication
      ),
    Valid: validModalApplication =>
      MA.ValidModalApplication.create(
        validModalApplication.mode,
        handleApplicationAction(validModalApplication.application, action) as A.ValidApplication
      ),
    Undetermined: undetermined => {
      switch (action.type) {
        case WorkQueueActionType.GET_APP_ENTRY_TYPE:
          return MA.LoadingModalApplication;
        case ApplicationActionType.SET_APPLICATION_TYPE: {
          const {payload} = action;
          const {
            applicationType,
            applicationMode,
            beneficiaryInformation,
            enrollmentData,
            policyNumber,
            products,
            achIndicatorQuality,
            pacDataResultData
          } = payload;

          switch (applicationType) {
            case ApplicationType.Ordinary: {
              if (applicationMode === ApplicationModeType.Quality) {
                const caseInformation = enrollmentData['caseInformation'];
                const clients = caseInformation['clients'] as object[];
                const agents = caseInformation['agents'] as object[];
                const policy = caseInformation['policy'] as object;

                const cashWithApplication = policy['cashWithApplication'] as object;

                const indices = getApplicantAndOwnerIndex(clients);
                const applicantIndex = indices[0];
                const ownerIndex = indices[1];

                const policyTypesSelected: Product[] = [getSelectedPolicy(policy, products)];

                const clientApplicant = clients[applicantIndex];

                const clientApplicantEmployeeModel = clientApplicant['employeeModel'];
                const clientApplicantAddress = clientApplicant['address'];

                const isApplicantOwner = applicantIndex === ownerIndex;

                const riders: any = policy['riders'];
                const adbRiderArr = riders?.filter(
                  (rider: {additionalProperties: boolean; tracInputLife70: string}) =>
                    rider.tracInputLife70.includes('ADB') && rider.additionalProperties == true
                );

                const accidentalDeathBenfit = adbRiderArr?.length > 0 ? 'YES' : 'NO';

                let accidentalDeathBenfitUnits = 0;
                adbRiderArr?.map((adbRider: {units: number}) => {
                  accidentalDeathBenfitUnits = adbRider.units;
                });

                let mib = true;

                const faceAmount = Number(policy['faceAmount']);

                if (faceAmount > 0) {
                  if (policy['planCode'] !== '') {
                    mib =
                      (policy['issueType'] === 'CGI' && faceAmount > 150000) ||
                      (policy['issueType'] === 'SI' && faceAmount > 50000);
                  }
                }
                const smokerCode = clients.filter(client => Boolean(client['proposedInsured']));

                const smokerCodeDependant = clients.filter(client => Boolean(client['proposedInsured'] == false));

                let smokerCodeVal = {} as object;
                let smokerCodeValDependant = {} as object;
                if (smokerCode?.length > 0) {
                  smokerCodeVal = smokerCode[0];
                }
                if (smokerCodeDependant?.length > 0) {
                  smokerCodeValDependant = smokerCodeDependant[0];
                }

                const qualityOrdinaryApplication = ValidOrdinaryApplication.create(
                  ValidOrdinaryCaseDetails.create(
                    UserAssignedPolicyNumber.create(policyNumber),
                    new LoadedPolicyTypes([], policyTypesSelected),
                    false,
                    [{policyNumberExists: false, policyNo: ''}],
                    false,
                    new EmptyString(),
                    new EmptyString(),
                    false
                  ),
                  getOrdinaryApplicantDemographics(
                    clientApplicant,
                    clientApplicantEmployeeModel,
                    clientApplicantAddress
                  ),
                  ownerIndex !== -1
                    ? getOwnerInfo(isApplicantOwner, ownerIndex, clients, clientApplicant, clientApplicantAddress)
                    : EmptyOwnerInfo,
                  EmptySecondaryAddressee,
                  getPrimaryBeneficiaries(beneficiaryInformation),
                  EmptyPrimaryBeneficiary,
                  EmptyContingentBeneficiary,
                  getContingentBeneficiaryList(beneficiaryInformation),
                  EmptyOrdCriticalIllness,
                  EmptyOrdinaryICRTN,
                  EmptyOrdinaryCancer,
                  EmptyDependents,
                  getDependentList(clients),
                  EmptyPolicyRecord,
                  getOrdinaryBillingAgent(caseInformation, clientApplicant, policy, pacDataResultData),
                  EmptyAgent,
                  getAgentsList(agents),
                  EmptyMessage,
                  EmptyBillingModes,
                  EmptyOrdinaryAWDStatus,
                  EmptyOrdinaryVerifyCriticalInformation,
                  EmptyOrdDisability,
                  EmptyOrdShop,
                  EmptyOrdinaryIwl,
                  EmptyOrdinaryHeartStroke,
                  EmptyOrdinaryAccident,
                  EmptyUWQuestions,
                  EmptyOrdUL,
                  EmptyOrdGLTERM,
                  EmptyOrdinaryPinCare,
                  EmptyOrdinaryAccidentNewYork,
                  EmptyOrdinaryCriticalIllnessNY,
                  EmptyHippaTrustees,
                  getPremiumDetails(
                    policy,
                    caseInformation['numberOfPays'],
                    caseInformation['billingMode'],
                    caseInformation['replacement'],
                    cashWithApplication,
                    caseInformation['totalPremium']
                  ),
                  EmptyOrdinaryAIP,
                  EmptyPlanCode,
                  getPlanCodes(policy),
                  ValidAdditionalProperties.create(
                    NonEmptyString.create('NO'),
                    NonEmptyString.create('NO'),
                    NonEmptyString.create('NO'),
                    NonEmptyString.create(smokerCodeVal['occSmokerCode']),
                    NonEmptyString.create(smokerCodeValDependant['occSmokerCode']),
                    NonEmptyString.create(policy['eliminationPeriod']),
                    policy['benefitPeriod'],
                    clientApplicant['age'],
                    NonEmptyString.create(accidentalDeathBenfit),
                    accidentalDeathBenfitUnits,
                    mib
                  )
                );

                return MA.ValidModalApplication.create(applicationMode, qualityOrdinaryApplication);
              }

              return MA.ValidModalApplication.create(applicationMode, EmptyOrdinaryApplication);
            }
            case ApplicationType.Group: {
              if (applicationMode === ApplicationModeType.Quality) {
                const caseInformation = enrollmentData['caseInformation'];
                const policy = caseInformation['policy'] as object[];
                const policyTypesSelected: Product[] = [getSelectedPolicy(policy, products)];
                const cashWithApplication = policy['cashWithApplication'] as object;
                const clients = caseInformation['clients'] as object[];
                const Indexes = getApplicantAndOwnerIndex(clients);
                const applicantIndex = Indexes[0];
                const clientApplicant = clients[applicantIndex];
                const agents = caseInformation['agents'] as object[];
                const replacement = caseInformation['replacement'] as boolean;
                const clientApplicantEmployeeModel = clientApplicant['employeeModel'];
                const clientApplicantAddress = clientApplicant['address'];
                const ownerIndex = Indexes[1];
                const isApplicantOwner = applicantIndex === ownerIndex;
                const riders: any = policy['riders'];
                const adbRiderArr = riders?.filter(
                  (rider: {additionalProperties: boolean; tracInputLife70: string}) =>
                    rider.tracInputLife70.includes('ADB') && rider.additionalProperties == true
                );

                const accidentalDeathBenfit = adbRiderArr?.length > 0 ? 'YES' : 'NO';

                const pwRiderArr = riders?.filter(
                  (rider: {additionalProperties: boolean; tracInputLife70: string}) =>
                    rider.additionalProperties == true &&
                    (rider.tracInputLife70.includes('PWP') || rider.tracInputLife70.includes('WP'))
                );

                const premiumWaiver = pwRiderArr?.length > 0 ? 'YES' : 'NO';

                let accidentalDeathBenfitUnits = 0;
                adbRiderArr?.map((adbRider: {units: number}) => {
                  accidentalDeathBenfitUnits = adbRider.units;
                });

                const smokerCode = clients.filter(client => Boolean(client['proposedInsured'] == true));
                const smokerCodeDependent = clients.filter(
                  client =>
                    Boolean(client['proposedInsured'] == false) && client['relationshipToPI'].toUpperCase() === 'SPOUSE'
                );

                let smokerCodeVal = {} as object;
                let smokerCodeValDependent = {} as object;
                if (smokerCode?.length > 0) {
                  smokerCodeVal = smokerCode[0];
                }
                if (smokerCodeDependent?.length > 0) {
                  smokerCodeValDependent = smokerCodeDependent[0];
                }

                const qualityGroupApplication = ValidGroupApplication.create(
                  ValidGroupCaseDetails.create(
                    UserAssignedCaseNumber.create(caseInformation['caseNumber']),
                    UserAssignedPolicyNumber.create(policyNumber),
                    new LoadedPolicyTypes([], policyTypesSelected),
                    NonEmptyString.create(caseInformation['caseName']),
                    achIndicatorQuality,
                    NonEmptyString.create(caseInformation['billingCode']),
                    NonEmptyString.create(caseInformation['situsState']),
                    NonEmptyString.create(''),
                    false,
                    false,
                    [{policyNumberExists: false, policyNo: ''}],
                    [],
                    false,
                    NonEmptyString.create(caseInformation['policy']['eeiIndicator']),
                    NonEmptyString.create(''),
                    false
                  ),
                  getGroupApplicantDemographics(clientApplicant, clientApplicantEmployeeModel, clientApplicantAddress),
                  ownerIndex !== -1
                    ? getOwnerInfo(isApplicantOwner, ownerIndex, clients, clientApplicant, clientApplicantAddress)
                    : EmptyOwnerInfo,
                  EmptySecondaryAddressee,
                  getPrimaryBeneficiaries(beneficiaryInformation),
                  EmptyPrimaryBeneficiary,
                  EmptyContingentBeneficiary,
                  getContingentBeneficiaryList(beneficiaryInformation),
                  EmptyGroupCriticalIllness,
                  EmptyGroupICRTN,
                  EmptyGroupCancer,
                  EmptyDependents,
                  getDependentList(clients),
                  EmptyPolicyRecord,
                  getGroupBillingAgent(caseInformation, clientApplicant, policy, pacDataResultData),
                  EmptyAgent,
                  getAgentsList(agents),
                  EmptyMessage,
                  EmptyBillingModes,
                  EmptyGroupAWDStatus,
                  EmptyGroupVerifyCriticalInformation,
                  EmptyGroupDisability,
                  EmptyGroupShop,
                  EmptyGroupIWL,
                  EmptyGroupHeartStroke,
                  EmptyGroupAccident,
                  EmptyUWQuestions,
                  EmptyGroupUL,
                  EmptyGroupGLTERM,
                  EmptyGroupPinCare,
                  EmptyGroupAccidentNewYork,
                  EmptyGroupCriticalIllnessNY,
                  EmptyHippaTrustees,
                  getPremiumDetails(
                    policy,
                    caseInformation['numberOfPays'],
                    caseInformation['billingMode'],
                    replacement,
                    cashWithApplication,
                    caseInformation['totalPremium']
                  ),
                  EmptyGroupAIP,
                  EmptyPlanCode,
                  getPlanCodes(policy),
                  ValidAdditionalProperties.create(
                    NonEmptyString.create('NO'),
                    NonEmptyString.create(premiumWaiver),
                    NonEmptyString.create('NO'),
                    NonEmptyString.create(smokerCodeVal['occSmokerCode']),
                    NonEmptyString.create(smokerCodeValDependent['occSmokerCode']),
                    NonEmptyString.create(policy['eliminationPeriod']),
                    policy['benefitPeriod'],
                    clientApplicant['age'],
                    NonEmptyString.create(accidentalDeathBenfit),
                    accidentalDeathBenfitUnits,
                    false
                  )
                );
                return MA.ValidModalApplication.create(applicationMode, qualityGroupApplication);
              }
              return MA.ValidModalApplication.create(applicationMode, EmptyGroupApplication);
            }
            case ApplicationType.NewYork:
              return MA.ValidModalApplication.create(applicationMode, EmptyNewYorkApplication);
            default:
              return undetermined;
          }
        }
        default:
          return undetermined;
      }
    },
  });
};

const getApplicantAndOwnerIndex = (clients: object[]) => {
  let applicantIndex = clients.findIndex(
    client => Boolean(client['proposedInsured']) && Boolean(client['policyOwner'])
  )!;

  let ownerIndex = applicantIndex;

  if (applicantIndex === -1) {
    applicantIndex = clients.findIndex(
      client => Boolean(client['proposedInsured']) && !Boolean(client['policyOwner'])
    )!;

    if (applicantIndex !== -1) {
      ownerIndex = clients.findIndex(client => !Boolean(client['proposedInsured']) && Boolean(client['policyOwner']))!;
    }
  }
  return [applicantIndex, ownerIndex];
};
